import controller from './customers.controller';

const template = require('./customers.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/customers/customers.component.js